import React from "react";
import {
    Box,
    Typography,
    CircularProgress,
} from "@mui/material";
import { MAIN_COLOR_RED } from "../assets/styles";
import aiLogo from "../assets/img/ai-logo.png";

interface StartShoppingStepProps {
    loadingProgress: number;
}

const StartShoppingStep: React.FC<StartShoppingStepProps> = ({
    loadingProgress,
}) => {
    return (
        <Box sx={{ textAlign: "center" }}>
            <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ color: MAIN_COLOR_RED, mb: 2 }}
            >
                Getting ready to shop...
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                We are processing your route according to the products on your list, and the constraints.
            </Typography>

            {/* Large Red Box with Loading Animation */}
            <Box
                sx={{
                    backgroundColor: MAIN_COLOR_RED,
                    borderRadius: 4,
                    p: 6,
                    mb: 4,
                    position: "relative",
                    minHeight: 300,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {/* Circular Loading Indicator */}
                <Box
                    sx={{
                        position: "relative",
                        width: 120,
                        height: 120,
                        mb: 3,
                        margin: "0 auto",
                    }}
                >
                    <CircularProgress
                        variant="indeterminate"
                        size={120}
                        thickness={4}
                        sx={{
                            color: "white",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "120px !important",
                            height: "120px !important",
                        }}
                    />
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1,
                            width: "60px",
                            height: "60px",
                        }}
                    >
                        <img
                            src={aiLogo}
                            alt="AI Logo"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                            }}
                        />
                    </Box>
                </Box>
                <Typography variant="body1" sx={{ color: "white", fontWeight: "medium" }}>
                    Loading your shopping list...
                </Typography>
            </Box>
        </Box>
    );
};

export default StartShoppingStep;

